import React from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { CUserType } from 'constants/user.const';
import { EUserType } from 'enums/base.enum';
import { Button, Typography } from 'antd';
import styled from 'styled-components';
import { PrimaryColor } from 'GlobalStyles';
import { FormWrapper } from 'GlobalStyles';
import BackgroundSource from 'assets/images/banners/12.webp';

const { Text, Title } = Typography;
const CompletedWrapper = styled.div`
  padding: 10px;
  text-align: center;
  background: no-repeat url(${BackgroundSource});
  background-position: center center;
  a.ant-btn-lg {
    line-height: 26px;
  }
`;
const Completed = () => {
  const userType = queryString.parse(useLocation().search)?.userType?.toString() as EUserType;

  return (
    <CompletedWrapper>
      <FormWrapper style={{ maxWidth: '380px' }}>
        <span style={{ color: `${PrimaryColor}` }}>
          <strong>{CUserType[userType]}</strong>
        </span>
        <Title level={2}>
          <span style={{ color: `${PrimaryColor}` }}>
            회원가입이
            <br />
            완료되었습니다.
          </span>
        </Title>
        <Text style={{ margin: '20px auto', display: 'block' }}>
          {userType === EUserType.Mentee ? (
            <div>Career Step에서 최고의 멘토와 다양한 컨텐츠를 만나보세요</div>
          ) : (
            <div>Career Step의 업계 최고 멘토진에 함께해 주셔서 감사합니다</div>
          )}
        </Text>
        <Button
          style={{ width: '100%', height: '45px', lineHeight: '45px' }}
          type='primary'
          size='large'
          href='/'
        >
          Career Step 시작하기
        </Button>
      </FormWrapper>
    </CompletedWrapper>
  );
};

export default Completed;
